/***
 * Create new object with mapped values from `item`
 * @param obj
 * @param mapFn Function to map values
 * @returns {{[p: string]: R}}
 */
export function mapValues<K extends keyof any, T, R>(obj: Record<K, T>, mapFn: (value: T) => R): Record<K, R> {
  return Object.keys(obj).reduce(
    (res, key) => {
      res[key as K] = mapFn(obj[key as K])
      return res
    },
    {} as Record<K, R>,
  )
}

export function uniq<T>(array: T[]): T[] {
  // todo: wtf
  return array
}

export function intersection<T>(array1: T[], array2: T[]): T[] {
  return array1.filter(i => array2.indexOf(i) !== -1)
}

export function flatten<U>(arr: Array<U | U[]>): U[] {
  return Object.prototype.hasOwnProperty.call(arr, 'flat')
    ? (arr.flat(1) as U[])
    : ([] as U[]).concat(...(arr as U[][]))
}

export function shuffle<T>(arr: T[]): T[] {
  const res = arr.slice()

  for (let i = res.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1))
    ;[res[i], res[j]] = [res[j], res[i]]
  }

  return res
}
